import type {TFunction} from 'i18next';

import {FieldErrorCode} from '../../forms/schemas';

const isFieldErrorCode = (value: string): value is FieldErrorCode => (Object.values(FieldErrorCode) as string[]).includes(value);

export function resolveFieldError(t: TFunction, sentinel: string | undefined, fieldLabel: string): string | undefined {
  if (!sentinel) {
    return undefined;
  }
  // Unknown sentinels (any zod message that isn't a FieldErrorCode) pass straight through to t().
  if (!isFieldErrorCode(sentinel)) {
    return t(sentinel);
  }
  switch (sentinel) {
    case FieldErrorCode.Required:
      return t('n_missing_field_error', {missingField: fieldLabel});
    case FieldErrorCode.InvalidEmail:
      return t('invalid_email');
    case FieldErrorCode.InvalidPhone:
      return t('invalid_phone');
    case FieldErrorCode.TooLong:
      return t('character_limit_exceeded');
  }
}
